import { loadState, saveState } from 'utils/storage';
import { ScenarioPlan } from 'views/playground/features/bluviu-nutrition-r2/types/scenario-plan.type';
import { UpdateStepTwoInput } from 'views/playground/features/bluviu-nutrition-r2/types/update-step-two-input.type';

export const putStepTwo = async (data: UpdateStepTwoInput): Promise<ScenarioPlan> => {
  const raw = loadState({ key: 'getPlaygroundScenarioPlan', storage: 'session' });

  const parsed = (typeof raw === 'string' ? JSON.parse(raw) : raw) as ScenarioPlan;

  const updatedScenarioPlan: ScenarioPlan = {
    ...parsed,
    stepTwoFields: {
      feedProgram: data.feedProgram,
    },
  }; // combine data and save in session for test

  saveState({ key: 'getPlaygroundScenarioPlan', storage: 'session', state: updatedScenarioPlan }); // save in session for persistent display

  return updatedScenarioPlan; // return combined data
};
